import React from 'react';
import { AccessibleFocusOutline } from './AccessibleFocusOutline';

export const HelpButton = ({ onClick = () => null, containerClasses = "", iconClasses = "text-4xl" }) => {

  return (
    <AccessibleFocusOutline classes={`flex items-center ${containerClasses}`}>
      <button onClick={onClick}>
        <div className={`ss-icon pt-1.5 leading-none ${iconClasses}`}>&#x2753;</div>
      </button>
    </AccessibleFocusOutline>
  )
}
